<template>
  <div class="app">
    <Card dis-hover>
      <div class="page-body">
        <Form ref="queryForm" :label-width="50" label-position="left" inline>
            <Row :gutter="20">
            	<Col span="5">
            		<FormItem label="姓名:":label-width="100">
            		  <Input v-model="query.name" placeholder="员工姓名" style="width: 200px"></Input>
            		</FormItem>
            	</Col>
            	<Col span="5">
            		<FormItem label="工号:" :label-width="100">
            		  <Input v-model="query.number"  style="width: 200px" placeholder="请输入工号"></Input>
            		</FormItem>
            	</Col>
            	<Col span="5">
            		<FormItem label="部门:" :label-width="100" style="width: 100%"><!--  multiple -->
            			<selectTree style="width:200px; " v-model="query.organizationUnitId"  :treeData="treeData" @on-select-change="selectChange" @on-remove="removeRoot" :showQuery='false' ></selectTree>
            		</FormItem>
            	</Col>
            	<Col span="5">
            		<FormItem label="岗位:" :label-width="100">
            		  <Select placeholder="请选择岗位"  style="width: 200px" v-model="query.post">
            			<Option value="">------</Option>
            			<Option v-for="item in postList" :key="item.value" :value="item.value">{{ item.name }}</Option>
            		  </Select>
            		</FormItem>
            	</Col>
            </Row>
			<Row :gutter="20">
				<Col span="5">
					<FormItem label="状态:":label-width="100">
					  <Select placeholder="请选择状态"  style="width: 200px" v-model="query.status">
						<Option value="">------</Option>
						<Option v-for="item in statusList" :key="item.value" :value="item.value">{{ item.name }}</Option>
					  </Select>
					</FormItem>
				</Col>
				<Col span="5" >
					<FormItem label="补休开始时间:" :label-width="100">
					  <DatePicker v-model="leaveStartTime" style="width: 200px" type="daterange" format="yyyy-MM-dd" placement="bottom-end" placeholder="请选择请假开始时间"></DatePicker>
					</FormItem>
				</Col>
				<Col span="5" >
					<FormItem label="补休结束时间:" :label-width="100" >
					  <DatePicker v-model="leaveEndTime" style="width: 200px" type="daterange" format="yyyy-MM-dd" placement="bottom-end" placeholder="请选择请假结束时间"></DatePicker>
					</FormItem>
				</Col>
			  <Button icon="ios-search" type="primary" size="default" @click="getpage(1)" class="toolbar-btn">查询</Button>
			  <Button icon="md-refresh" type="primary" size="default" @click="reset" class="toolbar-btn">重置</Button>
			  <Button icon="md-add" v-show="isShow申请" type="primary" size="default" @click="proxyCreateSale" class="toolbar-btn">发起补休申请</Button>
			</Row>
        </Form>
        <div>
          <Table :loading="loading" :columns="columns" no-data-text="暂无数据" border :data="list"></Table>
          <Page show-sizer show-total class-name="fengpage" :total="totalCount" class="margin-top-10" @on-change="pageChange" @on-page-size-change="pagesizeChange" :page-size="pageSize" :current="currentPage"></Page>
        </div>
      </div>
    </Card>
	<!-- <!-- 代申请 -->
	<div v-if='showCreate'>
		<CreateLeave :showCreate="showCreate" :leaveId="leaveId" :postList="postList" :leaveTypeList="selfLeaveTypeList" :isSelf="isSelf"  @close="closeCreateProjectModel"/>
	</div>
	<!-- 申请 -->
	<div v-if='showProxyCreate'>
		<ProxyCreateLeave :showCreate="showProxyCreate" :postList="postList" :leaveTypeList="leaveTypeList" :isSelf="isSelf" :leaveId="leaveId" @close="closeCreateProjectModel"/>
	</div>
	<!-- 详情 -->
	<div v-if='showDetail'>
		<Detail :showCreate="showDetail" :isExamine="isExamine" :postList="postList" :leaveTypeList="leaveTypeList" :isSelf="isSelf" :leaveId="leaveId" @close="closeCreateProjectModel"/>
	</div>
  </div>
</template>

<script>
import {
  getOverTimeLeaveListData,
  getPostSaleListInitInfo,
  examineLeave,
  getAfterPerson,
} from '../../../api/index'
import moment from 'moment'
import Util from '../../../lib/util'
 import ProxyCreateLeave from './proxyCreateOverTimeLeave'
 import CreateLeave from './createOverTimeLeave'
 import Detail from './detail'
import selectTree from '../../../components/selectTree/selectTree.vue'
export default {
  data() {
    return {
      query: {
		name: '',
		number: '',
		causeDepartment:'',
		organizationUnitId:null,
		post:null,
		status:null,
		
		MaxResultCount: 10,
		SkipCount: 0,
      },
      loading: false,
      columns: [],
      list: [],
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
	  
	  isPersonnel:false,
	  
	  postList: [], //岗位list
	  statusList: [], //状态list
	  leaveTypeList:[],//请假类型（带假期额度）
	  selfLeaveTypeList:[],//请假类型
	  leaveStartTime: [],
	  leaveEndTime: [],
	  treeData:[],
	  leaveId:0,
	  isSelf:false,
      showDetail: false, //详情弹框
      showCreate: false, //发起请假弹框
      showProxyCreate: false, //代发起请假弹框
	  isShow申请:false,
	  isExamine:false
	  
    }
  },
  components: {
	   ProxyCreateLeave,
	  // CreateLeave,
	  Detail,
	  selectTree
  },
  mounted() {
	  this.getUserSelectList()
    this.getpage()
	this.getTree()
    this.getColumn()
  },
  methods: {
	  //获取下拉框
	  async getUserSelectList() {
	    const { data } = await this.$Ajax.get(
	      '/api/services/app/OverTimeLeave/GetLeaveInitData'
	    )
	    this.postList = data.result.postList
	    this.statusList = data.result.statusList
	    this.leaveTypeList = data.result.leaveTypeList
		this.selfLeaveTypeList=data.result.selfLeaveTypeList
		this.isPersonnel=data.result.isPersonnel
		this.isShow申请=data.result.isShow申请
	  },
    async getTree(){
    	let reponse = await this.$Ajax.get(
    	  '/api/services/app/OrganizationUnit/GetOrganizationUnitTree'
    	)
    	console.log(reponse);
    	let list=reponse.data.result
    	this.editeTreeValue(list);
    	this.treeData = list;
    	console.log(this.treeData,"zzzz");
    	this.$emit('postComponent',this);
    },
    selectChange(data){
    	this.query.organizationUnitId = data
    },
    removeRoot(data){
    	this.query.organizationUnitId = data
    },
    editeTreeValue(data){
    	for (let i=0; i<data.length; i++) {
    		data[i].title = data[i].displayName
    		data[i].value = data[i].id
    		if(data[i].children){
    			if(data[i].children.length>0){
    			   data[i].expand=true
    			}
    			this.editeTreeValue(data[i].children)
    		}
    	}
    },
    async getpage(params) {
		// 格式化时间给后端
		if (this.leaveStartTime[0]) {
		  this.query.StartTimeStart = moment(this.leaveStartTime[0]).format('YYYY-MM-DD')
		}
		if (this.leaveStartTime[1]) {
		  this.query.StartTimeEnd = moment(this.leaveStartTime[1]).format('YYYY-MM-DD')
		}
		if (!this.leaveStartTime[0]) {
		  this.query.StartTimeStart = ''
		}
		if (!this.leaveStartTime[1]) {
		  this.query.StartTimeEnd = ''
		}
		// 格式化时间给后端
		if (this.leaveEndTime[0]) {
		  this.query.EndTimeStart = moment(this.leaveEndTime[0]).format('YYYY-MM-DD')
		}
		if (this.leaveEndTime[1]) {
		  this.query.EndTimeEnd = moment(this.leaveEndTime[1]).format('YYYY-MM-DD')
		}
		if (!this.leaveEndTime[0]) {
		  this.query.EndTimeStart = ''
		}
		if (!this.leaveEndTime[1]) {
		  this.query.EndTimeEnd = ''
		}
		
      this.query.MaxResultCount = this.pageSize
      this.query.SkipCount = (this.currentPage - 1) * this.pageSize
      if (params === 1) {
        this.query.SkipCount = 0
      }
      this.loading = true
      const res = await getOverTimeLeaveListData(this.query)
      this.list = res.data.result.items
      this.totalCount = res.data.result.totalCount
      this.loading = false
    },
    reset() {
      // 清空所有属性值
      Object.keys(this.query).forEach((key) => (this.query[key] = ''))
	  this.leaveStartTime = []
	  this.leaveEndTime = []
    },
	
    //新增弹框
    proxyCreateSale() {
      this.showProxyCreate = true
    },
	//新增弹框
	createSale() {
		this.isSelf=true
	  this.showCreate = true
	},
    //表格
    getColumn() {
      let _this = this
      this.columns = [
	  {
		title: '工单流水号',
		key: 'serialNumber',
	  },
    {
      title: '姓名',
      key: 'name',
    },
    {
      title: '工号',
      key: 'number',
    },
    {
      title: '部门',
      key: 'departmentText'
    },
    {
      title: '岗位',
	  key: 'postText'
    },
    {
      title: '补休时间',
	  key: 'leaveDateText'
    },
	{
	  title: '状态',
	  key: 'statusText'
	},
	{
	  title: '发起时间',
	  key: 'submitTimeText'
	},
    {
        title: '操作',
        width: 240,
        fixed: 'right',
        render: (h, params) => {
          return h('div', { style: 'paddingTop:5px;' }, [
			  h(
			    'Button',
			    {
			      props: {
			        type: 'primary',
			        size: 'small',
			      },
			  	style: {
			  	  marginRight: '5px',
			  	},
			      on: {
			        click: () => {
			          this.openDetail(params.row.id)
			        },
			      },
			    },
			    '详情'
			  ),
            h(
              'Button',
              {
                props: {
                  type: 'primary',
                  size: 'small',
                },
				style: {
				  marginRight: '5px',
				  display:
				    params.row.isShow编辑 && params.row.userId>0
				      ? 'inline-block'
				      : 'none',
				},
                on: {
                  click: () => {
                    this.openUpdateLeave(params.row)
                  },
                },
              },
              '编辑'
            ),
			h(
			  'Button',
			  {
			    props: {
			      type: 'primary',
			      size: 'small',
			    },
				style: {
				  marginRight: '5px',
				  display:
				    params.row.isShow编辑 && params.row.userId<=0
				      ? 'inline-block'
				      : 'none',
				},
			    on: {
			      click: () => {
			        this.openUpdateProxyLeave(params.row)
			      },
			    },
			  },
			  '编辑'
			),
			h(
			  'Button',
			  {
			    props: {
			      type: 'warning',
			      size: 'small',
			    },
			    style: {
					marginLeft: '5px',
			      marginRight: '5px',
			      display: params.row.isShow撤回 ? '' : 'none',
			    },
			    on: {
			      click: () => {
			        this.$Modal.confirm({
			          title: '确认是否撤回？',
			          okText: '确认',
			          cancelText: '取消',
			          onOk: async () => {
			            this.isShowDelete = true
			    
			            const { data } = await this.$Ajax.post(
			              `/api/services/app/OverTimeLeave/Withdraw?id=${params.row.id}`
			            )
			            if (data.success) {
			              this.$Message.success({ content: '撤回成功', duration: 5 })
			            } else {
			              this.$Message.error({ content: '撤回失败', duration: 5 })
			            }
			            this.isShowDelete = false
			            this.getpage()
			          },
			        })
			      },
			    },
			  },
			  '撤回'
			),
            h(
              'Button',
              {
                props: {
                  type: 'error',
                  size: 'small',
                },
                style: {
                  marginRight: '5px',
                  display: params.row.isShow删除 ? '' : 'none',
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '确认是否删除？',
                      okText: '确认',
                      cancelText: '取消',
                      onOk: async () => {
                        this.isShowDelete = true
    
                        const { data } = await this.$Ajax.delete(
                          `/api/services/app/OverTimeLeave/Delete?id=${params.row.id}`
                        )
                        if (data.success) {
                          this.$Message.success({ content: '删除成功', duration: 5 })
                        } else {
                          this.$Message.error({ content: '删除失败', duration: 5 })
                        }
                        this.isShowDelete = false
                        this.getpage()
                      },
                    })
                  },
                },
              },
              '删除'
            ),
          ])
        },
      },
    
  ]
    },
    
    //分页
    pageChange(page) {
      this.currentPage = page
      this.getpage()
    },
    pagesizeChange(pagesize) {
      this.pageSize = pagesize
      this.getpage()
    },
	openDetail(id){
		this.leaveId = id
		this.showDetail=true
	},
	openExamine(id){
		this.leaveId = id
		this.isExamine=true
		this.showDetail=true
	},
	examine(arr) {
	  this.$Modal.confirm({
	    title: '确认通过吗？',
	    okText: '确认',
	    cancelText: '取消',
	    onOk: async () => {
	      let res = await examineLeave(arr)
	      if (res.data.success) {
	        this.$Message.success({ content: '确认成功', duration: 5 })
	      } else {
	        this.$Message.error({ content: '确认失败', duration: 5 })
	      }
	      this.getpage()
	    },
	  })
	},
    // 打开编辑
    openUpdateLeave(leave) {
	  this.leaveId = leave.id
	  if(leave.userId!=null || leave.userId>0)
		this.isSelf=true
	    this.showProxyCreate = true
    },
	// 打开编辑
	openUpdateProxyLeave(leave) {
	  this.leaveId = leave.id
	  if(leave.userId!=null || leave.userId>0)
		this.isSelf=true
	  this.showProxyCreate = true
	},
	
	//关闭弹框
	closeCreateProjectModel(refresh) {
		this.leaveId=0
	  this.showCreate = false
	  this.showProxyCreate=false
	  this.showDetail=false
	  this.isExamine=false
	  this.isSelf=false
	  if (refresh) {
	    this.getpage()
	  }
	},
    exportFile() {
      var _this = this
      if (!_this.query.DesignName) {
        _this.query.DesignName = ''
      }
      if (!_this.query.Name) {
        _this.query.Name = ''
      }
      if (!_this.query.MouldName) {
        _this.query.MouldName = ''
      }
      if (!_this.query.StartCreationTime) {
        _this.query.StartCreationTime = ''
      }
      if (!_this.query.EndCreationTime) {
        _this.query.EndCreationTime = ''
      }
      if (!_this.query.Status) {
        _this.query.Status = ''
      }
      if (!_this.query.MouldNO) {
        _this.query.MouldNO = ''
      }
      if (!_this.query.CauseDepartment) {
        _this.query.CauseDepartment = ''
      }
      if (!_this.query.Type) {
        _this.query.Type = ''
      }
    //   const date = this.$moment(new Date()).format('yyyyMMDDHHmm')
    //   let consturl = `${this.$constDefinition.baseUrl}/api/Export/ExportPostSaleList?
    //                         DesignName=${_this.query.DesignName}
    //                         &Name=${_this.query.Name}
    //                         &MouldName=${_this.query.MouldName}
    //                         &StartCreationTime=${_this.query.StartCreationTime}
    //                         &EndCreationTime=${_this.query.EndCreationTime}
    //                         &Status=${_this.query.Status}
    //                         &MouldNO=${_this.query.MouldNO}
    //                         &CauseDepartment=${_this.query.CauseDepartment}
    //                         &Type=${_this.query.Type}` //下载地址url
    //   var xhr = new XMLHttpRequest()
    //   xhr.open('get', consturl, true) // get、post都可
    //   xhr.responseType = 'blob'
    //   xhr.setRequestHeader('Authorization', `Bearer ${Util.abp.auth.getToken()}`) //加请求头
    //   xhr.onload = function () {
    //     if (xhr.status == 200) {
    //       let blob = new Blob([this.response], {
    //         type: 'application/vnd.ms-excel',
    //       })
    //       var a = document.createElement('a')
    //       var url = window.URL.createObjectURL(blob)
    //       a.href = url
    //       a.download = `产品列表${date}.xlsx` // 文件名
    //     }
    //     a.click()
    //     window.URL.revokeObjectURL(url)
    //   }
    //   xhr.send()

      
        this.$downLoad('/api/Export/ExportPostSaleList', '产品列表', '.xlsx',  this.query)
    },
  },
}
</script>

<style lang="less" scoped>
.app {
  min-width: 1260px;
}
.ivu-upload {
  display: inline-block;
}
.ivu-btn {
  margin-left: 5px;
}
.spin {
  font-size: 20px;
}
</style>
